// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__mgWi1","boxTitle":"Qualiphy_boxTitle__3BH8B","box":"Qualiphy_box__2X6x1","toggleWrap":"Qualiphy_toggleWrap__1JXD4"};